<template>
  <div class="relative h-full">
    <div class="flex justify-between items-center p-4 bg-white relative z-60">
      <div
        :style="{ backgroundImage: 'url(' + settings.logo + ')' }"
        class="w-12 h-12 bg-no-repeat bg-center bg-contain"
      ></div>
      <div class="cursor-pointer" @click="toggleMenu()">
        <svg
          v-if="menuActive"
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6 cursor-pointer hover:text-cw-alt"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
        <svg
          v-if="!menuActive"
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6 cursor-pointer hover:text-cw-alt"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M4 6h16M4 12h16M4 18h16"
          />
        </svg>
      </div>
    </div>

    <!-- Admin Menu -->
    <div v-if="userAccess" class="relative z-20">
      <ul
        id="tenantAdminMenu"
        :class="[
          !adminMenuActive
            ? '-translate-y-full mouse-events-none top-12'
            : 'translate-y-0 top-0',
        ]"
        class="overflow-hidden w-full bg-bluegray-700 transition-translate duration-700 ease-in-out transform absolute left-0 z-20 flex flex-col items-center justify-center w-full"
      >
        <div class="items-center mt-6 pl-6 w-full">
          <p class="m-0 pb-0 text-white text-xs font-primary">
            CareerWise Portal
          </p>
          <p class="text-white text-xs font-primary">
            {{ settings.expo_post_count }} / {{ settings.expo_post_cap }} posts
          </p>
          <button
            v-if="!canPost"
            class="btn btn-trans-white py-1 px-2 font-normal mt-2 mb-2 text-white"
            @click="showPostPackModal"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              class="w-4 h-4 mr-1"
            >
              <path
                d="M10.75 4.75a.75.75 0 00-1.5 0v4.5h-4.5a.75.75 0 000 1.5h4.5v4.5a.75.75 0 001.5 0v-4.5h4.5a.75.75 0 000-1.5h-4.5v-4.5z"
              />
            </svg>
            Posts
          </button>
        </div>
        <li
          :class="
            (activeAdminMenuItem === 'NewPost' ? 'bg-gray-500 ' : '',
            canPost ? 'cursor-pointer' : 'opacity-20 cursor-not-allowed')
          "
          class="cursor-pointer py-2 px-6 w-full text-white hover:bg-gray-500 transition duration-150 ease-in-out"
          @click="openNewPost()"
        >
          New Post
        </li>
        <li
          :class="activeAdminMenuItem === 'Stats' ? 'bg-gray-500 ' : ''"
          class="cursor-pointer py-2 px-6 w-full text-white hover:bg-gray-500 transition duration-150 ease-in-out"
          @click="triggerManagerMenuItem('Statistics')"
        >
          Statistics Dashboard
        </li>
        <li
          :class="activeAdminMenuItem === 'Settings' ? 'bg-gray-500 ' : ''"
          class="cursor-pointer py-2 px-6 w-full text-white hover:bg-gray-500 transition duration-150 ease-in-out"
          @click="triggerManagerMenuItem('Settings')"
        >
          Profile Settings
        </li>
        <li
          :class="activeAdminMenuItem === 'Pages' ? 'bg-gray-500 ' : ''"
          class="cursor-pointer py-2 px-6 w-full text-white hover:bg-gray-500 transition duration-150 ease-in-out"
          @click="triggerManagerMenuItem('Pages')"
        >
          Manage Pages
        </li>
        <li
          :class="activeAdminMenuItem === 'Resources' ? 'bg-gray-500 ' : ''"
          class="cursor-pointer py-2 px-6 w-full text-white hover:bg-gray-500 transition duration-150 ease-in-out"
          @click="triggerManagerMenuItem('Resources')"
        >
          Manage Media Gallery
        </li>
        <li
          :class="activeAdminMenuItem === 'LogOut' ? 'bg-gray-500 ' : ''"
          class="cursor-pointer py-2 px-6 w-full text-white hover:bg-gray-500 transition duration-150 ease-in-out"
          @click="logout()"
        >
          Log Out
        </li>

        <li
          class="h-12 bg-black flex justify-center items-center px-6 cursor-pointer w-full"
          @click="adminMenuActive = !adminMenuActive"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            :class="adminMenuActive ? 'rotate-180' : ''"
            class="mr-4 transform transition-all duration-300 ease-in-out h-5 w-5 text-white"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M5 15l7-7 7 7"
            />
          </svg>
          <span class="text-white">Admin Panel</span>
        </li>
      </ul>
    </div>

    <div
      id="mobileMenu"
      :class="[menuActive ? 'opacity-100' : 'opacity-0 pointer-events-none']"
      class="flex justify-center items-center absolute top-full w-full z-90 transition-all duration-300"
    >
      <MenuContent :mobile="true" />
    </div>
  </div>
</template>

<script>
import { EventBus } from '../../../js/plugins/event-bus.js'
import MenuContent from './MenuContent.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    MenuContent,
  },

  data() {
    return {
      activeItem: 'Home',
      menuActive: false,
      menu: [],
      activeAdminMenuItem: '',
      adminMenuActive: false,
    }
  },

  computed: {
    // Set all map getters
    ...mapGetters({
      settings: 'shared/getSettings',
      userAccess: 'shared/getUserAccess',
      canPost: 'expo/canPost',
    }),
  },

  watch: {
    userAccess: {
      handler: function (yes) {
        yes
          ? this.$set(this, 'adminMenuActive', true)
          : this.$set(this, 'adminMenuActive', false)
      },

      deep: true,
    },

    menuActive: {
      handler: function (val) {
        EventBus.$emit('modal_state_changing', val)
      },

      deep: true,
    },
  },

  mounted() {
    EventBus.$on('closeMobileMenu', () => {
      this.$set(this, 'menuActive', false)
    })
  },

  methods: {
    openNewPost() {
      if (this.canPost) {
        EventBus.$emit('showModal', 'new-post')
      }
    },

    showPostPackModal() {
      EventBus.$emit('showModal', {
        action: 'expo-tenant-post-pack',
      })
    },

    logout() {
      EventBus.$emit('showModal', 'logout')
    },

    toggleMenu() {
      let active = this.menuActive ? false : true
      this.$set(this, 'menuActive', active)
      EventBus.$emit('toggleMenu', active)
      this.$set(this, 'adminMenuActive', false)
    },

    triggerManagerMenuItem(item = '') {
      this.$set(this, 'adminMenuActive', false)
      this.$set(this, 'activeAdminMenuItem', item)
      this.$router.push({ name: item })
    },
  },
}
</script>

<style scoped>
#mobileMenu {
  height: calc(100vh - 4rem);
  background: rgba(255, 255, 255, 0.97);
}
</style>
